"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function getFullStreamPath(topic, extraUrl) {
  var baseUrl = "/streams/".concat(topic);
  var path = extraUrl ? "".concat(baseUrl).concat(extraUrl) : baseUrl;
  return path;
}

exports.getFullStreamPath = getFullStreamPath;

function getDCListString(response) {
  var dcList = response.reduce(function (acc, elem, index) {
    if (index > 0) return "".concat(acc, ",").concat(elem.name);
    return elem.name;
  }, "");
  return dcList;
}

exports.getDCListString = getDCListString;